import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import NameRecurrencesDrillDown from "../../../components/Brand/Tagging/NameRecurrencesDrillDown";
import { NameRecurrenceType } from "../../../types/Brand";
import { Box, Breadcrumbs, IconButton, Typography } from "@mui/material";
import { RiFullscreenExitLine, RiFullscreenLine } from "@remixicon/react";

const TaggingSuggestionsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    setIsFullscreen((prev) => !prev);
  };

  const country = searchParams.get("country");
  const recurrence_type = searchParams.get("recurrence_type");
  const name_like = searchParams.get("name_like");
  const s_chain_id = searchParams.get("s_chain_id");

  useEffect(() => {
    if (!country || !recurrence_type || !name_like || !s_chain_id) {
      const redirectUrl = country
        ? `/data-ops/brands/tagging?country=${encodeURIComponent(country)}`
        : "/data-ops/brands/tagging";
      navigate(redirectUrl, { replace: true });
    }
  }, [country, recurrence_type, name_like, s_chain_id, navigate]);

  return (
    <Box
      sx={
        isFullscreen
          ? {
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "#fff",
              overflow: "auto",
              p: 5,
              pt: 0,
            }
          : {
              position: "relative",
              width: "auto",
              height: "auto",
              minHeight: "500px",
              overflow: "hidden",
              border: "1px solid #ccc",
              borderRadius: "4px",
              p: 5,
              mt: 2,
              backgroundColor: "#fff",
            }
      }
    >
      {/* Top Bar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          ...(isFullscreen && {
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            width: "100%",
            zIndex: 1000,
            p: 2,
          }),
        }}
      >
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            to={`/data-ops/brands/tagging?country=${country}`}
          >
            Name Recurrences Review
          </Link>
          <Typography color="textPrimary">names like: {name_like}</Typography>
        </Breadcrumbs>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Fullscreen Toggle Button */}
          <IconButton onClick={toggleFullscreen} sx={{ zIndex: 500 }}>
            {isFullscreen ? <RiFullscreenExitLine /> : <RiFullscreenLine />}
          </IconButton>
        </Box>
      </Box>

      <NameRecurrencesDrillDown
        country_code={country ?? ""}
        name_like={name_like ?? ""}
        name_recurrence_type={recurrence_type as NameRecurrenceType}
        suggested_chain_id={s_chain_id ?? ""}
      />
    </Box>
  );
};

export default TaggingSuggestionsPage;
